import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cx from 'classnames';
import { components } from 'react-select-5';
import type { GroupBase, MultiValueGenericProps } from 'react-select-5';

import s from './index.module.css';

export function MultiValueContainer<
  Option extends { value: string },
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
>(props: MultiValueGenericProps<Option, IsMulti, Group>) {
  const { attributes, setNodeRef, transform, transition, isOver, isDragging } = useSortable({
    id: props.data.value,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    maxWidth: '40%',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} tabIndex={1}>
      <components.MultiValueContainer
        {...props}
        innerProps={{
          ...props.innerProps,
          className: cx(props.innerProps.className, s.draggable, {
            over: isOver,
            dragging: isDragging,
            [s.dragging]: isDragging,
          }),
        }}
      />
    </div>
  );
}
